import { createStore } from 'vuex'

export default createStore({
  state: {
    file: null,
    showChatDialog: false,
    showSetTemplateDialog: false,
    showSetDetailsDialog: false,
    showSetReportDialog: false,
    showSetChatbotDialog: false,
    showDetailedReportDialog: false,
    showTransactionDialog: false,
    currentTransaction: null,
    template: "",
    report: "",
    details: "",
    currentInput: ""
  },
  getters: {
    file: state => state.file,
    showChatDialog: state => state.showChatDialog,
    showTransactionDialog: state => state.showTransactionDialog,
    showSetTemplateDialog: state => state.showSetTemplateDialog,
    showSetReportDialog: state => state.showSetReportDialog,
    showSetDetailsDialog: state => state.showSetDetailsDialog,
    showSetChatbotDialog: state => state.showSetChatbotDialog,
    showDetailedReportDialog: state => state.showDetailedReportDialog,
    currentTransaction: state => state.currentTransaction,
    template: state => state.template,
    report: state => state.report,
    currentInput: state => state.currentInput
  },
  mutations: {
    SET_FILE(state, payload) {
      state.file = payload
    },
    SET_SHOW_CHAT_DIALOG(state, payload) {
      state.showChatDialog = payload
    },
    SET_SHOW_SET_TEMPLATE_DIALOG(state, payload) {
      state.showSetTemplateDialog = payload
    },
    SET_SHOW_SET_REPORT_DIALOG(state, payload) {
      state.showSetReportDialog = payload
    },
    SET_SHOW_SET_DETAILS_DIALOG(state, payload) {
      state.showSetDetailsDialog = payload
    },
    SET_SHOW_TRANSACTION_DIALOG(state, payload) {
      state.showTransactionDialog = payload
    },
    SET_SHOW_SET_CHATBOT_DIALOG(state, payload) {
      state.showSetChatbotDialog = payload
    },
    SET_SHOW_DETAILED_REPORT_DIALOG(state, payload) {
      state.showDetailedReportDialog = payload
    },
    SET_TRANSACTION(state, payload) {
      state.currentTransaction = payload
    },
    SET_TEMPLATE(state, payload) {
      state.template = payload
    },
    SET_REPORT(state, payload) {
      state.report = payload
    },
    SET_DETAILS(state, payload) {
      state.details = payload
    },
    SET_CURRENT_INPUT(state, payload) {
      state.currentInput = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
